// extracted by mini-css-extract-plugin
export var block = "banner-module--block--3LJK5";
export var image = "banner-module--image--3a-pO";
export var content = "banner-module--content--aPSPS";
export var contentInner = "banner-module--contentInner--3X2k_";
export var title = "banner-module--title--1F2CW";
export var summary = "banner-module--summary--1DS3e";
export var button = "banner-module--button--1gbVr";